/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { Users, Download } from 'lucide-react';

function AdminClientsPage() {
    const [clients, setClients] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const token = localStorage.getItem('adminToken');

    const fetchClients = useCallback(async () => {
        setIsLoading(true); setError('');
        if (!token) { setError('Brak autoryzacji.'); setIsLoading(false); navigate('/admin/login'); return; }
        try {
            const response = await axios.get(`${apiUrl}/api/admin/clients`, { headers: { 'x-auth-token': token } });
            setClients(response.data);
        } catch (err) { setError(err.response?.data?.errors?.[0]?.msg || 'Nie udało się pobrać listy klientów.'); if (err.response?.status === 401 || err.response?.status === 403) { navigate('/admin/login');} }
        finally { setIsLoading(false); }
    }, [apiUrl, navigate, token]);

    useEffect(() => { fetchClients(); }, [fetchClients]);

    const handleExportCsv = async () => {
        if (!token) { alert('Brak autoryzacji.'); return; }
        try {
            const response = await axios.get(`${apiUrl}/api/admin/clients/csv`, {
                headers: { 'x-auth-token': token },
                responseType: 'blob', // Ważne dla pobierania plików
            });
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'lingland_klienci.csv');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error exporting clients CSV:", err);
            alert(err.response?.data?.errors?.[0]?.msg || 'Nie udało się wyeksportować listy klientów.');
        }
    };

    if (isLoading) return <div className="container" style={{paddingTop: '2rem'}}>Ładowanie listy klientów...</div>;
    if (error) return <div className="container submit-message error" style={{paddingTop: '2rem'}}>{error}</div>;

    return (
        <section className="admin-page section-bg-white" style={{padding: "40px 0", minHeight: 'calc(100vh - var(--header-height) - var(--footer-height, 150px))'}}>
            <div className="container">
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem'}}>
                    <h1>Panel Administratora - Klienci ({clients.length})</h1>
                    <div style={{display: 'flex', gap: '1rem'}}>
                        <button onClick={handleExportCsv} className="button-primary">
                            <Download size={16} style={{marginRight: '0.5rem'}}/> Eksportuj do CSV
                        </button>
                        <Link to="/admin/dashboard" className="button-secondary button-small-outline">← Wróć do Dashboardu</Link>
                    </div>
                </div>

                {clients.length === 0 && !isLoading ? (<p>Brak zarejestrowanych kontaktów klientów.</p>) : (
                    <div className="table-responsive-wrapper">
                        <table className="admin-table">
                            <thead><tr><th>Email</th><th>Nazwa / Firma</th></tr></thead>
                            <tbody>
                                {clients.map((client, index) => (
                                    <tr key={client.email + index}> {/* Użyj email + index jako klucza, bo email powinien być unikalny */}
                                        <td>{client.email}</td>
                                        <td>{client.name || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </section>
    );
}
export default AdminClientsPage;